<template>
  <div>
    <div v-if="activeForm" class="LKMunMehForm">
      <LKMunMehFormHeader
        v-model="currentTab"
        :mun-meh="munMeh"
        :slug="slug"
        :topic-slug="topicSlug"
        @click:next="goToFill"
        @excel:download="$emit('excel:download')"
        @excel:upload="$emit('excel:upload')"
      />

      <div class="LKMunMehForm__content">
        <router-link class="LKMunMehForm__content__link" :to="getListLink()">
          <h3 class="LKMunMehForm__title" v-text="munMeh.name" />
        </router-link>

        <hr class="LKMunMehForm__line">

        <v-tabs-items v-model="currentTab">
          <v-tab-item :key="1" :transition="false">
            <template v-if="munMeh.id">
              <div>
                <v-btn
                  color="primary"
                  rounded
                  outlined
                  class="mb-2"
                  style="margin-top: 1rem;"
                  :loading="isDownloading"
                  @click="onExcelDownload"
                  v-text="'Скачать шаблон'"
                />
              </div>
            </template>
            <v-btn
              color="primary"
              rounded
              outlined
              class="mb-2"
              style="margin-top: 1rem;"
              :loading="isUploadingLoading"
              @click="onExcelUpload"
              v-text="'Загрузить'"
            />

            <input
              v-show="false"
              ref="input"
              type="file"
              @input="onFileUpload($event.target.files)"
            >
            <div v-if="hasErrors" style="margin-top: 1rem;">
              Загруженный файл имеет ошибки.
            </div>
            <div v-else-if="fileUploaded" style="margin-top: 1rem;">
              Файл шаблона загружен.
            </div>

            <div v-if="hasErrors" style="margin-top: 1rem;">
              <v-row no-gutters>
                <v-col cols="12" class="mt-2">
                  <span>Ошибки загрузки шаблона:</span>
                </v-col>
              </v-row>

              <template v-if="errors['report']">
                <v-row
                  v-for="(error, index) in errors['report']"
                  :key="`error-${index}`"
                  no-gutters
                >
                  <v-col>
                    <p class="error--text">
                      {{ error }}
                    </p>
                  </v-col>
                </v-row>
              </template>
            </div>
          </v-tab-item>

          <v-tab-item :key="2" :transition="false">
            <v-row>
              <v-col cols="8">
                <h4
                  class="LKMunMehForm__content__title__header"
                  v-text="'Позиция оценивания'"
                />
              </v-col>
              <v-col cols="2" class="text-right">
                <h4
                  class="LKMunMehForm__content__title__header"
                  v-text="'Статус'"
                />
              </v-col>
              <v-col cols="2" class="text-right">
                <h4
                  class="LKMunMehForm__content__title__header"
                  v-text="'Максимальный балл'"
                />
              </v-col>
            </v-row>

            <template v-if="isGeneral">
              <LKMunMehFormRowLink
                v-for="(item, idx) in munMeh.form.data"
                :key="item.id"
                :get-link-builder="getLevelLinkBuilder"
                :idx="idx"
                :item="item"
                bold
              />
            </template>
            <template v-else>
              <LKMunMehFormRowLink
                v-for="(link, index) in openedLinks"
                :key="`Opened.${link.index}`"
                :get-link-builder="getLevelLinkBuilder"
                :idx="link.index"
                :item="link.level"
                :bold="index === 0"
              />

              <template v-if="hasParameters">
                <hr class="LKMunMehForm__line">

                <h4
                  class="LKMunMehForm__content__parameter__header"
                  v-text="'Параметры оценивания компонента'"
                />

                <div
                  v-for="parameter in parameters"
                  :key="parameter.id"
                  class="LKMunMehForm__content__parameter"
                  v-text="parameter.name"
                />
              </template>

              <template v-if="levelDescription">
                <hr class="LKMunMehForm__line">

                <div
                  class="LKMunMehForm__content__level-description"
                  v-text="levelDescription"
                />
              </template>
            </template>
          </v-tab-item>

          <v-tab-item :key="3" :transition="false">
            <LKMunMehLogsTable
              :form="activeForm"
              :indicator-ids-with-logs="getIndicatorIdsWithLogs()"
              @action:view="onJumpToIndicator"
            />
          </v-tab-item>
        </v-tabs-items>
      </div>

      <template v-if="currentTab === 1">
        <template v-if="!isGeneral">
          <div class="LKMunMehForm__content">
            <template v-if="!hasParameters">
              <LKMunMehFormRowLink
                v-for="(item, idx) in currentLevel.items"
                :key="item.id"
                :get-link-builder="getLevelLinkBuilder"
                :idx="idx"
                :item="item"
              />
            </template>

            <template v-else>
              <LKMunMehFormFourLevels
                ref="FourLevels"
                :mun-meh-id="munMeh.id"
                :parent="currentLevel"
                :disabled="isLoadingAsyncData"
                :parent-idx="latestIndex"
              />
            </template>
          </div>
        </template>

        <LKMunMehFormFooter
          v-if="hasParameters"
          :status="activeForm.status"
          :loading="isLoadingAsyncData"
          @save="onSaveThirdLevelDocuments"
          @main="onGoToForm"
          @prev="goToPrev"
          @next="goToNext"
        />
      </template>
    </div>
    <div v-else>
      <p>Формы не существует. Дальнейшая работа с формой невозможна.</p>
    </div>
  </div>
</template>

<script>
import LKMunMehLogsTable from '@/views/LKMunMeh/components/LKMunMehLogsList.vue'
import LKMunMehFormHeader from '@/views/LKMunMeh/Form/components/LKMunMehFormHeader.vue'
import LKMunMehFormFooter from '@/views/LKMunMeh/Form/components/LKMunMehFormFooter.vue'
import LKMunMehFormRowLink from '@/views/LKMunMeh/Form/components/LKMunMehFormRowLink.vue'
import LKMunMehFormFourLevels from '@/views/LKMunMeh/Form/components/LKMunMehFormFourLevels.vue'
import { LK_MUN_MEH_FORM_ROUTES as ROUTES } from '@/views/LKMunMeh/Form/utils'

import { lkMunMehFormMapper as StoreMapper } from '@/views/LKMunMeh/Form/store'
import { lkMunMehMapper as MainStoreMapper } from '@/views/LKMunMeh/store'

import MunMehLevelMixin from '@/views/LKMunMeh/mixins/MunMehLevelMixin'

import { LkMunMehApi } from '@/api/resources'
import { downloadLinkByGet } from '@/helpers/downloadBlob'

export default {
  name: 'LKMunMehForm',
  formRoute: ROUTES.FORM,
  anyLevelRoute: ROUTES.ANY_LEVEL,
  components: {
    LKMunMehLogsTable,
    LKMunMehFormFooter,
    LKMunMehFormHeader,
    LKMunMehFormRowLink,
    LKMunMehFormFourLevels,
  },
  mixins: [MunMehLevelMixin],
  data: () => ({
    currentTab: 1,
    isDownloading: false,
    fileUploaded: false,
    isUploadingLoading: false,
    errors: {},
  }),
  computed: {
    ...StoreMapper.mapState(['documents', 'deleteCheckedDocuments']),
    ...StoreMapper.mapGetters([
      'isNoDocuments4Level',
      'getDocumentsLength',
      'getDocuments',
      'getIndicatorIdsWithLogs',
    ]),
    formId() {
      return this.activeForm?.id
    },
    hasErrors() {
      // eslint-disable-next-line no-empty
      return Object.keys(this.errors).length > 0
    },
  },
  watch: {
    levels: {
      async handler() {
        if (this.hasParameters) {
          const { formId } = this
          const { currentLevel, hierarchyLevels, documents } = this

          try {
            this.isLoadingAsyncData = true
            await this.getThirdLevelDocuments({
              formId,
              thirdLevel: currentLevel,
            })
            this.updateThirdLevelStatuses({ hierarchyLevels, documents })
          } catch (e) {
            this.$notice.errors(e)
          }
          this.isLoadingAsyncData = false
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...StoreMapper.mapActions([
      'saveThirdLevelDocuments',
      'getThirdLevelDocuments',
      'getFormLoggedIndicators',
    ]),
    ...MainStoreMapper.mapMutations(['updateThirdLevelStatuses']),
    async asyncData() {
      if (this.formId) {
        await this.getFormLoggedIndicators(this.formId)
      }
    },
    async onSaveThirdLevelDocuments() {
      const result = await this.$refs.FourLevels.validate()

      const fourLevels = this.currentLevel?.items
      if (Array.isArray(fourLevels)) {
        fourLevels.forEach((el) => {
          if (!this.isNoDocuments4Level(el.id)) {
            const emptyLength = this.getDocuments(el.id).filter(
              ({ link }) => !link,
            ).length
            if (emptyLength > 0) {
              this.$notice.warning(
                `Ссылка на документ не указана (${el.name})`,
                { type: 'pink' },
              )
            }
          }
        })
      }

      if (!result) {
        this.$notice.warning('Ошибки валидации в форме')
        return false
      }

      this.isLoadingAsyncData = true
      try {
        const { formId } = this
        const { currentLevel, hierarchyLevels, documents } = this

        await this.saveThirdLevelDocuments({
          formId,
          thirdLevel: currentLevel,
        })
        this.$notice.create('Данные сохранены')

        this.updateThirdLevelStatuses({ hierarchyLevels, documents })
      } catch (e) {
        this.$notice.errors(e)
      }
      this.isLoadingAsyncData = false
      return true
    },
    async onExcelDownload() {
      const api = new LkMunMehApi()
      const { formId, munMeh } = this

      const link = api.downloadXlsx(formId)
      this.isDownloading = true
      try {
        await downloadLinkByGet(link, `${munMeh.name}.xlsx`)
      } catch (e) {
        this.$notice.errors(e)
      }
      setTimeout(() => {
        this.isDownloading = false
      }, 1500)
    },
    onExcelUpload() {
      this.$refs.input.click()
    },
    async onFileUpload(files) {
      const api = new LkMunMehApi()
      const [file] = files

      this.fileUploaded = false
      this.isUploadingLoading = true

      this.errors = {}

      try {
        await api.uploadXlsx(this.formId, file)
      } catch (e) {
        if (e.errors) {
          try {
            this.parseTemplateErrors(e.errors)
          } catch (err) {
            // eslint-disable-next-line no-console
            console.error(err)
          }
          this.isUploadingLoading = false
          this.fileUploaded = true
        } else {
          this.isUploadingLoading = false
          this.fileUploaded = true
          this.$notice.errors(e)
        }
      }
      this.$refs.input.value = null
      this.isUploadingLoading = false
      this.fileUploaded = true
    },
    parseTemplateErrors(errors) {
      const textErrors = []
      errors[0].forEach((err) => Object.entries(err)
        .map(([key, value]) => `${key} - ${value}`)
        .forEach((er) => {
          textErrors.push(er)
        }))

      this.errors = { report: textErrors }
    },
    onJumpToIndicator(v) {
      const { indicator_id } = v
      if (indicator_id) {
        const url = this.getIndicatorUrlById(indicator_id)
        if (url) {
          this.currentTab = 1
          this.goToIndicatorByUrl(url)
        }
      }
    },
  },
}
</script>

<style scoped lang="scss">
.LKMunMehForm {
  @import "~@/views/LKMunMeh/styles/_MunMehFormStylesheet.scss";
}
</style>
